import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Friendly fallback shown when a render crash is caught by Sentry.ErrorBoundary.
export default function ErrorFallback({ resetError }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-50 px-4"
      data-testid="error-boundary-fallback"
    >
      <div className="max-w-md w-full text-center space-y-5">
        <div className="w-14 h-14 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
          <AlertTriangle className="w-7 h-7 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Something went wrong</h1>
        <p className="text-sm text-gray-500">
          We hit an unexpected error and our team has been notified. You can try again or head back home.
        </p>
        <div className="flex items-center justify-center gap-3 pt-1">
          <button
            onClick={() => { if (resetError) resetError(); }}
            data-testid="error-retry-btn"
            className="px-5 py-2.5 rounded-full text-sm font-bold text-white bg-gray-900 hover:bg-gray-800 transition-colors"
          >
            Try again
          </button>
          <button
            onClick={() => { window.location.href = '/'; }}
            data-testid="error-home-btn"
            className="px-5 py-2.5 rounded-full text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
          >
            Go home
          </button>
        </div>
      </div>
    </div>
  );
}
